import { api } from '@services';

const generateType = (actionType = 'CUSTOM', reducer = 'ORGANISM/WORLDCLOCK') => `${reducer}/${actionType}`;

export const fetchTime = () => {
	return async (dispatch, getState) => {
		const onOK = async (res) => {
			const localTimes = res.info || {};
			const localTimesList = Object.keys(localTimes).map((key) => ({ time: localTimes[key], name: key }));
			const obj = { پکن: 'دبی', دبی: 'استانبول', استانبول: 'مسکو', مسکو: 'هامبورگ', هامبورگ: 'پکن' };
			const filteredList = localTimesList.filter((item) => obj[item.name]);

			await dispatch({
				type: generateType('CUSTOM'),
				payload: {
					...getState().organism.worldClock,
					localTimes,
					localTimesList,
					filteredList,
				},
			});
		};

		const onStatus = async (status) => {
			await dispatch({
				type: generateType('CUSTOM'),
				payload: {
					...getState().organism.worldClock,
					_localTimes: status,
				},
			});
		};

		api.$config_fetch_Time({ onOK, onStatus }, {});
	};
};
